import React, { Component } from "react";
import { connect } from "react-redux";
import {
  fetchTagData,
  fetchTagsList,
  postUserTag,
  setPaginationFirstValue,
  setPaginationSecondValue,
  setViewRecords,
  setRecordsShow,
  deactiveTag,
} from "./TagSlice";
import { bindActionCreators } from "redux";
import { getDateTimeFormate } from "../../sharedfiles/helper";
import Vpagination from "../../sharedfiles/Vpagination";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import ButtonGroup from "../Common/Buttons/ButtonGroup";
import Skelton from "../Common/skeleton/Skeleton";
import { COMMON_CONSTANTS, TAG_CONSTANTS } from "../../sharedfiles/Constants";
import NoDataFound from "../Common/table/NoDataFound";
import { playerTagData } from "../Common/data/mapData";
import Tooltips from "../Common/Tooltip";
import { TagInfo, Tagging_Segmentation } from "../../sharedfiles/tooltipMsgs";
import { Select } from "../../ui";
import { Button } from "../../ui/button";
import { 
  Select as ShadcnSelect, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "../../ui/select";
import { Label } from "../../ui/label";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
import TableToolbar from "../Common/table/TableToolbar";

// Class components can't use hooks directly, so the table (the only part
// that needs useColumnPreferences) is extracted into this sibling
// functional component - the class above stays untouched otherwise.
const TagsTableBody = ({ tagsData, onToggleStatus }) => {
  const headers = [
    TAG_CONSTANTS.th_tagType,
    TAG_CONSTANTS.header_tagName,
    TAG_CONSTANTS.th_appliedOn,
    TAG_CONSTANTS.status,
    TAG_CONSTANTS.action,
  ];
  const tooltips = [TagInfo.tagType, TagInfo.tagName, TagInfo.Applied_On, TagInfo.status, TagInfo.action];
  const rowAccessors = [
    (item) => item.type,
    (item) => item.tagName,
    (item) => (item.appliedOn ? getDateTimeFormate(item.appliedOn) : "-"),
    (item) => (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
        item.status ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-800"
      }`}>
        {item.status ? "Active" : "Inactive"}
      </span>
    ),
    (item) => (
      <div className="flex gap-2">
        <Button
          variant={item.status ? "default" : "outline"}
          size="sm"
          type='button'
          id='bankactivesave'
          onClick={() => onToggleStatus(item)}
          disabled={item.status}
        >
          Activate
        </Button>
        <Button
          variant={item.status === false ? "destructive" : "outline"}
          size="sm"
          type='button'
          id='bankactivecancel'
          onClick={() => onToggleStatus(item)}
          disabled={item.status === false}
        >
          Deactivate
        </Button>
      </div>
    ),
  ];
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("tagsTags", headers);

  return (
    <div className='relative rounded-lg border bg-card overflow-hidden shadow-sm'>
      <TableToolbar
        columns={allColumns}
        onToggle={toggleVisibility}
        onReorder={reorder}
        onReset={resetToDefault}
      />
      <Table scrollKey="tagsTags">
        <TableHeader>
          <TableRow>
            {visibleIndices.map((origIdx) => (
              <TableHead key={origIdx} className="whitespace-nowrap">
                <div className='flex items-center gap-2'>
                  <span>{headers[origIdx]}</span>
                  <Tooltips info={tooltips[origIdx]} />
                </div>
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {tagsData &&
            Object.keys(tagsData).length > 0 &&
            tagsData.data &&
            Array.isArray(tagsData.data) &&
            tagsData.data.length > 0 ? (
            tagsData.data.map((item, index) => {
              return (
                <TableRow key={index}>
                  {visibleIndices.map((origIdx) => (
                    <TableCell key={origIdx} className='text-sm'>{rowAccessors[origIdx](item)}</TableCell>
                  ))}
                </TableRow>
              );
            })
          ) : (
            <NoDataFound colspan={visibleIndices.length} />
          )}
        </TableBody>
      </Table>
    </div>
  );
};

class Tags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: localStorage.getItem("userId"),
      errorControl: false,
      tagType: "",
      tagName: "",
      tagId: "",
      id: "",
      itemToDeleteId: "",
      tagTypeList: JSON.parse(localStorage.getItem("tagTypeList")),
      deactiveTag: "",
      activeStatus: "",
      tagNameError: "",
      tagTypeError: "",
      csvData: [],
      pdfBody: [],
      resetCall: false,
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.handleActivation = this.handleActivation.bind(this);
    this.setDeleteTag = this.setDeleteTag.bind(this);
    this.addTag = this.addTag.bind(this);
    this.exportPDF = this.exportPDF.bind(this);
    this.updateTableToDocs = this.updateTableToDocs.bind(this);
    this.callApi = this.callApi.bind(this);
    this.handleTagStatus = this.handleTagStatus.bind(this);
  }
  changeHandler(e) {
    e.target.value !== "" && this.setState({ tagTypeError: false });
    this.setState({
      [e.target.name]: e.target.value,
    });
    // this.setState({ id: e.target.id });
    e.target.value !== "" && this.setState({ controlError: false });
    e.target.value && this.getTags();
  }
  handleTagStatus(item) {
    this.props.dispatch(deactiveTag(item))
  }
  onChangeHandler(e) {
    const value = e?.target?.value || e;
    this.setState({ tagName: value });
    value !== "" && this.setState({ tagNameError: false });
    const id = this.props?.getTagsList &&
      Object.keys(this.props.getTagsList).length > 0 &&
      this.props?.getTagsList?.data &&
      Array.isArray(this.props?.getTagsList?.data) &&
      this.props.getTagsList.data.filter((item) =>
        item.tagName === value
      );
    this.setState({ id: id[0]?.id });
  }

  callApi(pageNumber, itemPerPage, playerId = localStorage.getItem("userId"), silent = false) {
    if (!silent) {
      this.props.dispatch(setViewRecords(false));
    }
    this.props.dispatch(
      fetchTagData(
        playerId,
        pageNumber - 1,
        itemPerPage,
      )
    );
    this.setState({ resetCall: false });
  }

  headers = [["TAG TYPE", "TAG NAME", "APPLIED ON", "TAG STATUS"]];
  exportPDF() {
    const title = "Add Tags Report";
    exportPDFC(title, this.headers, this.state.pdfBody);
  }

  updateTableToDocs() {
    const data =
      this.props.tagsData.data &&
      this.props.tagsData.data.map((p) => [
        p.type,
        p.tagName,
        p.appliedOn ? getDateTimeFormate(p.appliedOn) : "-",
        p.tagId,
      ]);
    this.setState({ pdfBody: data });
    this.setState({
      csvData:
        data.length > 0 ? [this.headers[0], ...data] : [this.headers[0], []],
    });
  }

  handleActivation(e) {
    localStorage.setItem(`${e.target.id}`, `${e.target.value}`);
    this.setState({ activeStatus: e.target.value });
    this.setState({ itemToDeleteId: e.target.id });
  }

  addTag() {
    const userId = localStorage.getItem("userId");
    if (this.state.tagType === "") {
      this.setState({ tagTypeError: true });
    }
    if (this.state.tagName === "") {
      this.setState({ tagNameError: true });
    }
    if (this.state.tagType !== "" && this.state.tagName !== "") {
      localStorage.setItem(
        "tagTypeList",
        JSON.stringify(this.state.tagTypeList)
      );
      this.props.dispatch(postUserTag(userId, this.state.id));

      this.emptyState();
    }
  }
  setDeleteTag = (index) => {
    this.setState({ deactiveTag: index });
  };

  getTags() {
    this.props.dispatch(fetchTagsList(0, 1000));
  }
  emptyState() {
    this.setState({
      tagType: "",
      tagName: "",
      tagNameError: "",
      tagTypeError: "",
    });
  }

  reset() {
    this.emptyState();
    this.props.dispatch(setPaginationFirstValue(1));
    this.props.dispatch(setPaginationSecondValue(25));
    this.props.dispatch(setViewRecords(false));
    this.props.dispatch(setRecordsShow([1, 25]));
    this.callApi(1, 25, localStorage.getItem("userId"));
  }
  fetchTagsAdded(silent = false) {
    let playerId = localStorage.getItem("userId");
    this.callApi(
      this.props.paginationFirstValue,
      this.props.paginationSecondValue,
      playerId,
      silent
    );
  }

  mountingFetcher() {
    const dataExist =
      this.props.tagsData && Object.keys(this.props.tagsData).length > 0;
    if (dataExist) {
      // Data from a previous load already lives in redux (e.g. switching back
      // to this tab) - show it immediately and refresh in the background
      // instead of flashing the loader over it.
      this.updateTableToDocs();
    }
    this.fetchTagsAdded(dataExist);
    const data = JSON.parse(localStorage.getItem("tagTypeList"));
    this.setState({ tagTypeList: data });
  }
  componentDidMount() {
    this.mountingFetcher();
  }

  componentDidUpdate(prevProps) {

    if (prevProps.tagsData !== this.props.tagsData) {
      this.updateTableToDocs();
    }

    if (prevProps.userId != localStorage.getItem("userId")) {
      this.callApi(
        this.props.paginationFirstValue,
        this.props.paginationSecondValue,
        localStorage.getItem("userId")
      );
    }
  }


  render() {
    let tagNames = localStorage.getItem("tagTypeList");
    // let tagNamesArray = JSON.parse(tagNames);
    return (
      <>
        <div className='space-y-6'>
          {/* Add Tags Card */}
          <div className='rounded-lg border bg-card shadow-sm p-6'>
            <div className='mb-6'>
              <h2 className='text-lg font-semibold text-foreground'>Add New Tag</h2>
              <p className='text-sm text-muted-foreground mt-1'>Assign tags to organize and categorize player data</p>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4'>
              <Select
                title={"Tag Type"}
                name={"tagType"}
                ids={"tagType"}
                value={this.state.tagType}
                setValue={(val) => this.changeHandler(val)}
                options={playerTagData}
                info={Tagging_Segmentation.Tag_Type}
                errorMsg={this.state.tagTypeError && "Please select tag type"}
              />
              <div className="space-y-2">
                <Label htmlFor="tagName" className="flex items-center gap-2">
                  <span className='text-sm font-medium text-foreground'>{TAG_CONSTANTS.header_tagName}</span>
                  <Tooltips info={Tagging_Segmentation.Assign_tagName} />
                </Label>
                <ShadcnSelect
                  value={this.state.tagName}
                  onValueChange={this.onChangeHandler}
                >
                  <SelectTrigger id="tagName" className="w-full">
                    <SelectValue placeholder={COMMON_CONSTANTS.ddlOpt_select} />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="__PLACEHOLDER__">{COMMON_CONSTANTS.ddlOpt_select}</SelectItem>
                    {Object.keys(this.props.getTagsList).length > 0 &&
                      this.props?.getTagsList?.data
                        .filter((item) =>
                          item.tagType.includes(this.state.tagType.toUpperCase())
                        )
                        .map((item, index) => {
                          return (
                            <SelectItem key={index} value={item.tagName} data-id={item.id}>
                              {item.tagName}
                            </SelectItem>
                          );
                        })}
                  </SelectContent>
                </ShadcnSelect>
                {this.state.tagNameError && (
                  <div className='text-sm text-destructive mt-1 flex items-center gap-1'>⚠ Please select tag name</div>
                )}
              </div>
            </div>
            
            {/* Action Buttons */}
            <div className='pt-6 mt-6 border-t bg-muted -mx-6 -mb-6 px-6 pb-6'>
              <div className='flex justify-center gap-3'>
              <ButtonGroup
                freezButton={this.props.viewOnlyuser}
                groupNames={["Add", "Reset"]}
                idsearch={"AddTag"}
                idreset={"Tagreset"}
                submit={(e) => this.addTag(e)}
                reset={(e) => this.reset(e)}
              />
              </div>
            </div>
          </div>

          {/* Results Section */}
          <div className='space-y-4' id='result'>
              <div className='w-full'>
                <Vpagination
                  data={this.props.tagsData.data}
                  totalRecords={this.props.tagsData.totalRecords}
                  paginationFirstValue={this.props.paginationFirstValue}
                  paginationSecondValue={this.props.paginationSecondValue}
                  setPaginationFirstValue={setPaginationFirstValue}
                  setPaginationSecondValue={setPaginationSecondValue}
                  recordsShow={this.props.recordsShow}
                  setRecordsShow={setRecordsShow}
                  isVisible={this.props.viewRecords}
                  setIsVisible={setViewRecords}
                  csvData={this.state.csvData}
                  exportPDF={this.exportPDF}
                  callApi={this.callApi}
                  csvFileName={"Add Tags report"}
                  resetCall={this.state.resetCall}
                />
              </div>
              {!this.props.viewRecords ? (
                <Skelton />
              ) : (
                <TagsTableBody tagsData={this.props.tagsData} onToggleStatus={(item) => this.handleTagStatus(item)} />
              )}
            </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    displayValue: state.sidebar.displayValue,
    tagsData: state.tags.tagsData,
    paginationFirstValue: state.tags.paginationFirstValue,
    paginationSecondValue: state.tags.paginationSecondValue,
    recordsShow: state.tags.recordsShow,
    userId: state.playersearch.userId,
    getTagsList: state.tags.getTagsList,
    TagPostData: state.tags.TagPostData,
    tagId: state.tags.tagId,
    viewRecords: state.tags.viewRecords,
    viewOnlyuser: state.dashboard.viewOnlyuser,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators({}, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Tags);
